// extracted by mini-css-extract-plugin
module.exports = {"ChannelCellContainer":"ChannelCell_ChannelCellContainer__2VJrk","ChannelItem":"ChannelCell_ChannelItem__3sUp3"};